import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  heading: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: "19px",
    textAlign: "center",
    color: "#000",
    fontFamily: "Cairo",
  },
  subHeading: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: "16px",
    color: "#FF923D",
    textAlign: "center",
    maxWidth: 188,
    fontFamily: "Cairo",
  },
  resetMsgText: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: "16px",
    textAlign: "center",
    color: "#999999",
    marginTop: 4,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  button: {
    width: "100%",
    height: 40,
    fontSize: 22,
    marginTop: 11,
  },
  successHeading: {
    fontSize: 16,
    fontWeight: 500,
    textAlign: "center",
    color: "#000",
  },
  iconMail: {
    fontSize: 53,
    color: "#FF923D",
    margin: "30px 0px 30px 0px",
  },
  input: {
    marginTop: 24,
  },
  mailSent: {
    color: "#3C4858",
    fontSize: 14,
    fontWeight: 600,
    marginBottom: 26,
    textAlign: "center",
    maxWidth: 210,
    lineHeight: "16px",
  },
  descText: {
    fontSize: 14,
    fontWeight: 400,
    textAlign: "center",
    color: "#999",
    maxWidth: 289,
  },
  error: {
    width: "100%",
    textAlign: "center",
    justifyContent: "center",
    marginBottom: 10,
  },
  emailWrapper: {
    width: "100%",
    marginBottom: 15,
  },
  helperTextLtr: {
    textAlign: "left",
  },
  helperTextRtl: {
    textAlign: "right",
  },
}));
